// OPS Occult Library visual archive UI v2 — image-first museum record treatment.
(()=>{
  const key=(value)=>String(value||'').trim().toLowerCase();

  const MATERIAL_PROFILES=[
    {
      match:'Illustration_of_3_hands_in_Chyromancy',
      medium:'Pen-and-ink manuscript drawing',
      process:'Hand-drawn line illustration',
      colour:'Monochrome',
      visual:'Contour drawing with dense symbolic labels mapped directly onto the hands.'
    },
    {
      match:'Plate_XXII-_Palmistry_chart_of_right_hand',
      medium:'Copperplate engraving',
      process:'Intaglio engraving',
      material:'Printing ink on paper',
      colour:'Monochrome',
      visual:'Fine engraved line, compact lettering and planetary symbols organised as a reference diagram.'
    },
    {
      match:'Chart_showing_the_basic_elements_of_phrenology',
      medium:'Colour lithograph',
      process:'Lithographic print',
      material:'Printing ink on paper',
      colour:'Colour',
      visual:'Printed diagrams, portraits and hand studies arranged as a dense comparative chart.'
    },
    {
      match:'Chief_Lines_of_the_Hand',
      medium:'Printed book diagram',
      process:'Black-and-white line illustration',
      material:'Ink on paper',
      colour:'Monochrome',
      visual:'Simplified outline drawing with named palm lines prioritising legibility over pictorial detail.'
    },
    {
      match:'Fotothek_df_tg_0006469',
      medium:'Copper engraving print on paper',
      process:'Copperplate engraving',
      material:'Ink on paper',
      dimensions:'26.3 × 17 cm',
      colour:'Monochrome',
      visual:'A vertically organised engraved diagram using fine line and labelled zones to turn a metaphysical hierarchy into a measured instrument.'
    },
    {
      match:'The_music_of_the_spheres.jpg',
      medium:'Printed cosmological diagram',
      process:'Early printed book illustration',
      material:'Ink on paper',
      colour:'Monochrome',
      visual:'A vertical cosmological scheme combining figures, planetary levels, musical intervals and ruled diagrammatic structure.'
    },
    {
      match:'Musical_scales_or_range_of_sound_ascribed_by_Kepler',
      medium:'Printed book diagram',
      material:'Ink on paper',
      colour:'Monochrome',
      visual:'Dense typographic and musical notation arranged as an analytical page rather than a pictorial scene.'
    },
    {
      match:'Musurgiaorgan.jpg',
      medium:'Printed book illustration',
      material:'Ink on paper',
      colour:'Monochrome',
      visual:'Architectural instrument imagery used as a cosmological diagram, with strong bilateral structure and labelled components.'
    },
    {
      match:'Songbook_of_Zeghere_van_Male',
      medium:'Illuminated music manuscript',
      process:'Pen-and-watercolour manuscript decoration',
      material:'Ink and watercolour on manuscript leaf',
      colour:'Colour',
      visual:'Music notation and text share the page with hand-drawn figural initials and marginal decoration.'
    },
    {
      match:'Zeghere_s0',
      medium:'Historiated manuscript initial',
      process:'Pen-and-watercolour manuscript decoration',
      material:'Ink and watercolour on manuscript leaf',
      colour:'Colour',
      visual:'A readable letterform contains or supports a miniature scene; drawn ornament is integrated into the character rather than applied as a separate border.'
    },
    {
      match:'Abraxas_I1679.jpg',
      medium:'Engraved gemstone amulet',
      process:'Stonecutting / gemstone engraving',
      material:'Jasper with iron',
      dimensions:'1.3 × 1 cm',
      colour:'Stone object; colour museum photograph',
      visual:'A very small oval amulet carries the composite figure through incised grooves and compact attributes rather than printed shading.'
    },
    {
      match:'Abraxas_seu_Apistopistus_-_Talisman_pg.037',
      medium:'Antiquarian printed plate',
      process:'Printed line illustration',
      material:'Ink on paper',
      colour:'Monochrome',
      visual:'Multiple talismanic specimens are isolated and arranged for comparison, with inscriptions and figures treated as catalogue evidence.'
    },
    {
      match:'Special:Redirect/file/Abraxas.png',
      medium:'Engraved book illustration',
      process:'Printed line engraving',
      material:'Ink on paper',
      colour:'Monochrome',
      visual:'A nineteenth-century redrawing with a heavier silhouette, modelled anatomy and illustrative texture than the compact ancient gem.'
    },
    {
      match:'Gema_o_Piedra_Abraxas',
      medium:'Antiquarian book illustration',
      process:'Printed line reproduction',
      material:'Ink on paper',
      colour:'Monochrome',
      visual:'A compact scholarly line drawing keeps the inscription and composite figure legible as an archaeological or antiquarian specimen.'
    },
    {
      match:'Cluny_-_Mero_-_Croix-Talisman',
      medium:'Nielloed silver talisman cross',
      process:'Incised decoration with niello inlay',
      material:'Silver with niello',
      colour:'Metal object; colour photograph',
      visual:'Dark inlaid signs and lettering sit inside bright silver, making the inscription part of the object surface rather than a separate drawn diagram.'
    },
    {
      match:'Hebrew_MS_19_Wellcome_L0023928',
      medium:'Manuscript page',
      process:'Handwritten charm text',
      visual:'Dense cursive manuscript writing places the charm formula inside a working page of prescriptions rather than an isolated modern symbol chart.'
    },
    {
      match:'Abrakadabra%2C_Nordisk_familjebok',
      medium:'Encyclopedia line diagram',
      process:'Printed typographic diagram',
      material:'Ink on paper',
      colour:'Monochrome',
      visual:'A clean letter-triangle is stripped of manuscript context; repeated capitals diminish line by line to form the familiar wedge.'
    },
    {
      match:'Bayeux_Tapestry_scene32_Halley_comet',
      medium:'Narrative embroidery',
      process:'Wool embroidery',
      material:'Coloured wool thread on linen cloth',
      colour:'Colour; part of the ten-colour wool palette used across the embroidery',
      visual:'Figures, inscription and comet are built from stitched contour and filled colour inside a continuous narrative band.'
    },
    {
      match:'Olaus_Magnus_-_On_Suddenly_Appearing_Rings',
      medium:'Woodcut',
      process:'Relief print from a cut block',
      material:'Ink on paper',
      colour:'Monochrome',
      visual:'Heavy black contour, hatched texture and simplified atmospheric forms make rings, rays and comet readable at book-page scale.'
    },
    {
      match:'L0005342',
      medium:'Printed book illustration',
      process:'Historical printed illustration; exact print process not stated in the source record',
      material:'Ink on paper',
      colour:'Monochrome',
      visual:'Comet and terrestrial plague scene share one compact field; dense line and repeated figures turn a reported prodigy into a visual chronicle.'
    },
    {
      match:'Lunar_Halo_at_Fort_Conger',
      medium:'Engraving',
      process:'Printed engraving',
      material:'Ink on paper',
      colour:'Monochrome',
      visual:'Measured circular halo geometry and restrained landscape shading give the atmospheric phenomenon a documentary rather than emblematic treatment.'
    },
    {
      match:'gutenberg.org/cache/epub/66583/images/i_175.jpg',
      medium:'Printed reproduction of an earlier woodcut',
      process:'Book reproduction of a fifteenth-century woodcut image',
      material:'Ink on paper',
      colour:'Monochrome',
      visual:'Simple contour and interior hatch marks present the eagle-stone as a specimen illustration rather than a polished mineral portrait.'
    },
    {
      match:'De_rerum_fossilium-010v-1',
      medium:'Natural-history book illustration',
      process:'Printed specimen illustration',
      material:'Ink on paper',
      colour:'Monochrome',
      visual:'Several irregular stones are grouped as specimens, using outline and limited internal marks to distinguish form rather than theatrical symbolism.'
    },
    {
      match:'M0016861',
      medium:'Photographic record of a mounted amulet',
      process:'Museum object photography',
      material:'Stone or mineral substance mounted in silver',
      colour:'Colour photograph',
      visual:'The irregular natural substance sits inside a silver pendant mount; surface, edge and scale are visible as an object rather than an imagined eagle-stone diagram.'
    }
  ];

  const profileFor=(source)=>{
    const haystack=`${source?.sourceUrl||''} ${source?.imageUrl||''}`;
    return MATERIAL_PROFILES.find((profile)=>haystack.includes(profile.match));
  };

  const enrichData=()=>{
    const entries=window.OPS_OCCULT_EDITORIAL?.entries;
    if(!Array.isArray(entries)) return false;
    entries.forEach((entry)=>{
      if(!Array.isArray(entry.visualSources)) return;
      entry.visualSources.forEach((source)=>{
        const profile=profileFor(source);
        if(!profile) return;
        ['medium','process','material','dimensions','colour','visual'].forEach((field)=>{
          if(!source[field] && profile[field]) source[field]=profile[field];
        });
      });
    });
    return true;
  };

  const dateRange=(sources=[])=>{
    const years=[];
    sources.forEach((source)=>{
      const matches=String(source?.date||'').match(/\b(?:1[0-9]{3}|[2-9][0-9]{2})\b/g)||[];
      matches.forEach((year)=>years.push(Number(year)));
    });
    if(!years.length) return '';
    const min=Math.min(...years);
    const max=Math.max(...years);
    return min===max ? String(min) : `${min}–${max}`;
  };

  const factRow=(label,value)=>{
    if(!value) return null;
    const row=document.createElement('div');
    const dt=document.createElement('dt');
    const dd=document.createElement('dd');
    dt.textContent=label;
    dd.textContent=value;
    row.append(dt,dd);
    return row;
  };

  const rebuildCard=(card,source)=>{
    if(card.dataset.archiveUi==='2') return;
    card.dataset.archiveUi='2';
    const copy=card.querySelector('.ops-library__visual-source-copy');
    if(!copy) return;

    const title=copy.querySelector('h4');
    const originalDl=copy.querySelector(':scope > dl');
    const attribution=copy.querySelector(':scope > .ops-library__visual-source-attribution');
    const sourceLink=copy.querySelector(':scope > .ops-library__visual-source-link');
    const note=[...copy.querySelectorAll(':scope > p')].find((p)=>
      !p.classList.contains('ops-library__visual-source-period') &&
      !p.classList.contains('ops-library__visual-source-attribution')
    );

    const identity=document.createElement('p');
    identity.className='ops-library__visual-source-identity';
    identity.textContent=[source?.creator,source?.institution].filter(Boolean).join(' · ');
    if(identity.textContent && title) title.insertAdjacentElement('afterend',identity);

    const materialFacts=document.createElement('dl');
    materialFacts.className='ops-library__visual-material-facts';
    [
      factRow('Medium',source?.medium),
      factRow('Process',source?.process),
      factRow('Material',source?.material),
      factRow('Size',source?.dimensions),
      factRow('Colour',source?.colour),
      factRow('Visual',source?.visual)
    ].filter(Boolean).forEach((row)=>materialFacts.appendChild(row));
    if(materialFacts.children.length){
      (identity.textContent ? identity : title)?.insertAdjacentElement('afterend',materialFacts);
    }

    const details=document.createElement('details');
    details.className='ops-library__visual-source-record';
    const summary=document.createElement('summary');
    summary.textContent='Full catalogue record';
    details.appendChild(summary);
    [originalDl,note,attribution,sourceLink].filter(Boolean).forEach((node)=>details.appendChild(node));
    copy.appendChild(details);
  };

  const transformArchive=(archive)=>{
    if(!archive || archive.dataset.archiveUi==='2') return;
    enrichData();

    const article=archive.closest('.ops-library__article--editorial');
    const title=article?.querySelector('.ops-library__entry-hero h2')?.textContent?.trim();
    const entry=(window.OPS_OCCULT_EDITORIAL?.entries||[]).find((item)=>key(item?.title)===key(title));
    const sources=entry?.visualSources||[];

    const layout=article?.querySelector(':scope > .ops-library__entry-layout');
    if(article && layout && archive.parentElement!==article) article.insertBefore(archive,layout);

    const head=archive.querySelector('.ops-library__visual-archive-head');
    if(head){
      const eyebrow=head.querySelector('.ops-library__eyebrow');
      if(eyebrow) eyebrow.textContent='VISUAL ARCHIVE';
      const heading=head.querySelector('h3');
      if(heading) heading.textContent='Reference wall';
      const prose=[...head.querySelectorAll(':scope > p')].find((p)=>!p.classList.contains('ops-library__eyebrow'));
      if(prose){
        const range=dateRange(sources);
        prose.className='ops-library__visual-archive-index';
        prose.textContent=`${sources.length} catalogue ${sources.length===1?'record':'records'}${range?` · ${range}`:''}`;
      }
    }

    const cards=[...archive.querySelectorAll('.ops-library__visual-source-card')];
    cards.forEach((card,index)=>rebuildCard(card,sources[index]||{}));
    archive.dataset.archiveUi='2';
  };

  const process=()=>{
    enrichData();
    document.querySelectorAll('[data-visual-archive]').forEach(transformArchive);
  };

  const style=document.createElement('style');
  style.textContent=`
    .ops-library__article--editorial>.ops-library__visual-archive{margin:1rem 0 2.5rem;padding:1.15rem 0 2rem;border-top:1px solid rgba(22,22,22,.2);border-bottom:1px solid rgba(22,22,22,.2)}
    .ops-library__visual-archive-head{display:flex;align-items:baseline;gap:.8rem;flex-wrap:wrap;max-width:none!important;margin-bottom:1rem!important}
    .ops-library__visual-archive-head h3{margin:0!important;font-size:clamp(1.3rem,2vw,1.8rem)!important}
    .ops-library__visual-archive-index{margin:0!important;font-size:.78rem!important;letter-spacing:.06em;text-transform:uppercase;opacity:.68}
    .ops-library__visual-source-grid{grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:1px!important;background:rgba(22,22,22,.18);border:1px solid rgba(22,22,22,.18)}
    .ops-library__visual-source-card{border:0!important;background:#fff!important}
    .ops-library__visual-source-image{aspect-ratio:1/1!important;background:#f4f4f2!important;border-bottom:1px solid rgba(22,22,22,.12)}
    .ops-library__visual-source-image img{padding:.8rem;box-sizing:border-box}
    .ops-library__visual-source-copy{padding:1rem 1rem 1.1rem!important}
    .ops-library__visual-source-period{margin-bottom:.3rem!important}
    .ops-library__visual-source-copy h4{margin-bottom:.35rem!important}
    .ops-library__visual-source-identity{margin:.15rem 0 .75rem!important;font-size:.8rem!important;line-height:1.35;opacity:.72}
    .ops-library__visual-material-facts{margin:0!important;border-top:1px solid rgba(22,22,22,.1)}
    .ops-library__visual-material-facts>div{display:grid;grid-template-columns:74px 1fr;gap:.7rem;padding:.38rem 0;border-bottom:1px solid rgba(22,22,22,.08)}
    .ops-library__visual-material-facts dt{font-size:.67rem;text-transform:uppercase;letter-spacing:.06em;font-weight:700}
    .ops-library__visual-material-facts dd{margin:0;font-size:.82rem;line-height:1.4}
    .ops-library__visual-source-record{margin-top:.8rem;border-top:1px solid rgba(22,22,22,.12)}
    .ops-library__visual-source-record summary{cursor:pointer;padding:.7rem 0 .15rem;font-size:.7rem;font-weight:700;letter-spacing:.06em;text-transform:uppercase;list-style-position:inside}
    .ops-library__visual-source-record>dl{margin:.65rem 0!important}
    .ops-library__visual-source-record>p{font-size:.8rem!important;line-height:1.45}
    .ops-library__visual-source-record .ops-library__visual-source-attribution{font-size:.72rem!important}
    @media(min-width:1280px){.ops-library__visual-source-grid{grid-template-columns:repeat(3,minmax(0,1fr))!important}}
    @media(max-width:749px){
      .ops-library__article--editorial>.ops-library__visual-archive{margin-top:.6rem;padding-top:.9rem}
      .ops-library__visual-source-grid{grid-template-columns:1fr!important}
      .ops-library__visual-source-image{aspect-ratio:4/5!important}
      .ops-library__visual-archive-head{gap:.45rem}
    }
  `;
  document.head.appendChild(style);

  const start=()=>{
    process();
    const target=document.querySelector('[data-library-reader]')||document.body;
    const observer=new MutationObserver(()=>process());
    observer.observe(target,{subtree:true,childList:true});
  };

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();
